import { Place } from './place';

export type Vehicle = {
  id: string;
  name: string;
  licensePlate: string;
  vehicleModelName: string;
  chassisNumber: string;
  endOfAdmission?: Date | null;
  vehicleTypeId: string;
  vehicleRegistrationDate: Date | null;
  wheelchair: boolean;
  wheelchairSeats: number;
  liftingPlatform: boolean;
  seats: number;
  comment: string;
  driverId: string | null;
  transportationCompany: string | null;
  vehiclePlace: Place;
  unavailableFrom?: Date | null;
};

export type VehicleUpdateWrapper = {
  vehicle: Vehicle;
  status: 'OK' | 'VEHICLE_USED_IN_TOURS';
};

export type VehicleType = {
  id: string;
  name: string;
  vehicleTypeClass: string;
};

export enum VehicleFetchingType {
  WITH_RESPECTING_UNAVAILABLE_FROM_DATE = 'WITH_RESPECTING_UNAVAILABLE_FROM_DATE',
  WITHOUT_RESPECTING_UNAVAILABLE_FROM_DATE = 'WITHOUT_RESPECTING_UNAVAILABLE_FROM_DATE',
}
